export default {"src":"/_next/static/media/slider-indicator-full.b879bb1b.svg","height":69,"width":69,"blurWidth":0,"blurHeight":0};